module.exports = __webpack_public_path__ + "static/media/about_us_path.a2235e84.svg";